import { useAppState } from 'hooks/useAppState';

export const useUserToBlockedState = () => {
  const { userToBlockedState } = useAppState();

  return userToBlockedState;
};
